import React from 'react';
import ReactMarkdown from 'react-markdown'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism'
import remarkGfm from 'remark-gfm'
import rehypeKatex from 'rehype-katex'
import 'github-markdown-css'
import './index.less'


export const MarkDown = ({ code }) => {
  return <ReactMarkdown className='markdown-body' children={code} rehypePlugins={[rehypeKatex]} remarkPlugins={[[remarkGfm, { singleTilde: false }]]} components={{
    code({ node, inline, className, children, ...props }) {
      const match = /language-(\w+)/.exec(className || '')
      return !inline && match ? (
        <SyntaxHighlighter
          children={String(children).replace(/\n$/, '')}
          style={dark}
          language={match[1]}
          PreTag="div"
          {...props}
        />
      ) : (
        <code className={className} {...props}>
          {children}
        </code>
      )
    }
  }}></ReactMarkdown>
}